import React, { memo } from 'react';
import { string, oneOf, func, bool, object } from 'prop-types';

import { ReactComponent as ExportIcon } from 'assets/icons/file-download.svg';

const ButtonWithIcon = ({
  type,
  testId,
  title,
  className,
  onClick,
  isDisabled,
  icon: Icon,
}) => {
  return (
    <button
      data-testid={testId}
      type={type}
      className={`btn h-10 py-2 px-0 flex-shrink-0 ${className}`}
      onClick={type === 'button' ? onClick : undefined}
      disabled={isDisabled}
    >
      <span className="flex items-center justify-evenly">
        {Icon && (
          <Icon className="h-4 w-2.5 fill-current flex-shrink flex-grow-0" />
        )}
        <p className="text-sm">{title}</p>
      </span>
    </button>
  );
};

ButtonWithIcon.propTypes = {
  type: oneOf(['button', 'submit']),
  testId: string,
  title: string,
  className: string,
  onClick: func,
  isDisabled: bool,
  icon: object,
};
ButtonWithIcon.defaultProps = {
  className:
    'bg-white rounded border border-brand-primary text-brand-primary w-24',
  onClick: undefined,
  testId: 'button',
  type: 'button',
  isDisabled: false,
  title: 'Export orders',
  icon: ExportIcon,
};

export default memo(ButtonWithIcon);
